// extracted by mini-css-extract-plugin
export default {"wrapper":"toggleButton_wrapper__QDW7s","toggle":"toggleButton_toggle__dyIBR","label":"toggleButton_label__fgy9P"};